module.exports = __webpack_public_path__ + "static/media/video-icon.b61efbeb.svg";